import React from "react";
import PropTypes from "prop-types";

const CardShortSvg = ({
  imageUrl = "",
  imageAlt = "",
  type = "category",
  children = null,
  className = "",
  ...rest
}) => {
  const cardSvgClass = `card__icon--svg ${className}`;
  const quote1Svg = (
    <svg width="47" height="34" viewBox="0 0 47 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.9375 13.8125C15.4238 13.8125 19.875 18.2637 19.875 23.75C19.875 29.3398 15.4238 33.6875 9.9375 33.6875C4.34766 33.6875 0 29.3398 0 23.75V13.8125C0 6.56641 5.90039 0.5625 13.25 0.5625C15.0098 0.5625 16.5625 2.11523 16.5625 3.875C16.5625 5.73828 15.0098 7.1875 13.25 7.1875C9.52344 7.1875 6.625 10.1895 6.625 13.8125V14.4336C7.66016 14.123 8.69531 13.8125 9.9375 13.8125ZM36.4375 13.8125C41.9238 13.8125 46.375 18.2637 46.375 23.75C46.375 29.3398 41.9238 33.6875 36.4375 33.6875C30.8477 33.6875 26.5 29.3398 26.5 23.75V13.8125C26.5 6.56641 32.4004 0.5625 39.75 0.5625C41.5098 0.5625 43.0625 2.11523 43.0625 3.875C43.0625 5.73828 41.5098 7.1875 39.75 7.1875C36.0234 7.1875 33.125 10.1895 33.125 13.8125V14.4336C34.1602 14.123 35.1953 13.8125 36.4375 13.8125Z"
        fill="url(#paint0_linear_19_8035)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_19_8035"
          x1="23"
          y1="-2.5"
          x2="23"
          y2="62.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#46BB95" />
          <stop offset="1" stopColor="#11505A" />
        </linearGradient>
      </defs>
    </svg>
  );
  const quote2Svg = (
    <svg width="47" height="34" viewBox="0 0 47 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.9375 13.8125C15.4238 13.8125 19.875 18.2637 19.875 23.75C19.875 29.3398 15.4238 33.6875 9.9375 33.6875C4.34766 33.6875 0 29.3398 0 23.75V13.8125C0 6.56641 5.90039 0.5625 13.25 0.5625C15.0098 0.5625 16.5625 2.11523 16.5625 3.875C16.5625 5.73828 15.0098 7.1875 13.25 7.1875C9.52344 7.1875 6.625 10.1895 6.625 13.8125V14.4336C7.66016 14.123 8.69531 13.8125 9.9375 13.8125ZM36.4375 13.8125C41.9238 13.8125 46.375 18.2637 46.375 23.75C46.375 29.3398 41.9238 33.6875 36.4375 33.6875C30.8477 33.6875 26.5 29.3398 26.5 23.75V13.8125C26.5 6.56641 32.4004 0.5625 39.75 0.5625C41.5098 0.5625 43.0625 2.11523 43.0625 3.875C43.0625 5.73828 41.5098 7.1875 39.75 7.1875C36.0234 7.1875 33.125 10.1895 33.125 13.8125V14.4336C34.1602 14.123 35.1953 13.8125 36.4375 13.8125Z"
        fill="url(#paint0_linear_508_466)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_508_466"
          x1="31"
          y1="37"
          x2="31.5"
          y2="2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FF6A00" />
          <stop offset="1" stopColor="#FDD25F" />
        </linearGradient>
      </defs>
    </svg>
  );

  return (
    <div className={cardSvgClass}>
      {imageUrl ? (
        <div className="circle-wrapper">
          <div className="circle-background"></div>
          <img src={imageUrl} width="20" height="20" alt={imageAlt} className="circle-image" />
        </div>
      ) : type === "quote1" ? (
        quote1Svg
      ) : type === "quote2" ? (
        quote2Svg
      ) : null}
    </div>
  );
};

CardShortSvg.propTypes = {
  type: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  className: PropTypes.string,
  imageUrl: PropTypes.string,
  imageAlt: PropTypes.string
};

export default CardShortSvg;
